/* Pishuw — Free-gift quick-view
   Makes Kaching free-gift cards (real products) open a detail modal:
   merged image gallery (product + variant images), clickable variant
   thumbnails that scroll the gallery, and the product description.
   Express Shipping (empty image alt) stays inert. Loaded with defer. */
(function () {
  if (window.__dcGiftReady) return;
  window.__dcGiftReady = true;

  var GAP = 8;
  var cache = {};

  var modal = document.createElement('div');
  modal.id = 'dc-gift-modal';
  modal.className = 'dc-gift-overlay';
  modal.hidden = true;
  modal.innerHTML = '<div class="dc-gift-popup" role="dialog" aria-modal="true" aria-label="Free gift details"><button type="button" class="dc-gift-close" aria-label="Close">&times;</button><div class="dc-gift-body"></div></div>';
  document.body.appendChild(modal);
  var body = modal.querySelector('.dc-gift-body');

  function open() { modal.hidden = false; requestAnimationFrame(function () { modal.classList.add('is-open'); }); }
  function close() { modal.classList.remove('is-open'); setTimeout(function () { modal.hidden = true; }, 250); }
  function handleize(s) { return s.toLowerCase().trim().replace(/['’™®©]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function getJs(h) { return fetch('/products/' + h + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }); }
  function sized(src) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700'; }
  function base(u) { return (u || '').split('?')[0]; }

  function resolve(title) {
    if (cache[title]) return Promise.resolve(cache[title]);
    return getJs(handleize(title)).catch(function () {
      return fetch('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=4')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          var m = items.filter(function (p) { return p.title.trim().toLowerCase() === title.trim().toLowerCase(); })[0] || items[0];
          if (!m) throw new Error('not found');
          return getJs(m.url.split('?')[0].split('/products/').pop());
        });
    }).then(function (p) { cache[title] = p; return p; });
  }

  function render(p) {
    var imgs = (p.images || []).slice();
    (p.variants || []).forEach(function (v) {
      if (v.featured_image && v.featured_image.src && !imgs.some(function (s) { return base(s) === base(v.featured_image.src); })) imgs.push(v.featured_image.src);
    });
    if (!imgs.length && p.featured_image) imgs = [p.featured_image];

    var gallery = imgs.map(function (s, i) { return '<img class="dc-gift-gimg" data-idx="' + i + '" src="' + sized(s) + '" alt="' + (p.title || '') + '" loading="lazy">'; }).join('');

    var vWithImg = (p.variants || []).filter(function (v) { return v.featured_image && v.featured_image.src; });
    var variantsHtml = '';
    if (vWithImg.length > 1) {
      variantsHtml = '<div class="dc-gift-variants-label">Available styles</div><div class="dc-gift-variants">' +
        vWithImg.map(function (v) {
          var gi = imgs.findIndex(function (s) { return base(s) === base(v.featured_image.src); });
          return '<div class="dc-gift-variant" data-idx="' + gi + '"><img src="' + sized(v.featured_image.src) + '" alt="' + v.title + '" loading="lazy"><span>' + v.title + '</span></div>';
        }).join('') + '</div>';
    }

    body.innerHTML =
      (gallery ? '<div class="dc-gift-gallery-wrap"><div class="dc-gift-gallery">' + gallery + '</div>' +
        (imgs.length > 1 ? '<button type="button" class="dc-gift-arrow dc-gift-arrow--prev" aria-label="Previous">‹</button><button type="button" class="dc-gift-arrow dc-gift-arrow--next" aria-label="Next">›</button>' : '') +
        '</div>' : '') +
      '<span class="dc-gift-tag">FREE GIFT</span>' +
      '<h3 class="dc-gift-title">' + (p.title || '') + '</h3>' +
      variantsHtml +
      '<div class="dc-gift-desc">' + (p.description || '') + '</div>';

    var gal = body.querySelector('.dc-gift-gallery');
    var locked = true;
    function unlock() { locked = false; }
    function pinFirst() { if (locked && gal) gal.scrollLeft = 0; }
    function goTo(i) { unlock(); if (gal && i >= 0) gal.scrollTo({ left: i * (gal.clientWidth + GAP), behavior: 'smooth' }); }
    if (gal) {
      var prev = body.querySelector('.dc-gift-arrow--prev'), next = body.querySelector('.dc-gift-arrow--next');
      if (prev) prev.addEventListener('click', function () { unlock(); gal.scrollBy({ left: -(gal.clientWidth + GAP), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { unlock(); gal.scrollBy({ left: gal.clientWidth + GAP, behavior: 'smooth' }); });
      // Keep the strip on the first image until the user swipes/taps — lazy images
      // decoding at different times would otherwise re-snap it mid-way on mobile.
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { gal.addEventListener(ev, unlock, { passive: true }); });
      pinFirst();
      gal.querySelectorAll('.dc-gift-gimg').forEach(function (im) { if (!im.complete) im.addEventListener('load', pinFirst, { once: true }); });
      requestAnimationFrame(pinFirst);
      setTimeout(pinFirst, 60);
      setTimeout(pinFirst, 200);
      setTimeout(pinFirst, 500);
    }
    body.querySelectorAll('.dc-gift-variant').forEach(function (el) {
      el.addEventListener('click', function () {
        body.querySelectorAll('.dc-gift-variant').forEach(function (x) { x.classList.remove('is-active'); });
        el.classList.add('is-active');
        goTo(parseInt(el.dataset.idx, 10));
      });
    });
    body.scrollTop = 0;
  }

  function clickGift(title) {
    body.innerHTML = '<div class="dc-gift-loading">Loading…</div>';
    open();
    resolve(title).then(render).catch(function (e) {
      console.warn('[dc-gift]', title, e);
      body.innerHTML = '<p style="padding:20px;color:#888;">Details unavailable.</p>';
    });
  }

  var GIFT = '.kaching-bundles__progressive-gifts__gift';
  var IMG = '.kaching-bundles__progressive-gifts__gift__image';
  var VARIANT = '.kaching-bundles__bar-variant, .kaching-bundles__swatch-dropdown';
  function attach() {
    document.querySelectorAll(GIFT).forEach(function (gift) {
      if (gift.dataset.dcGiftBound) return;
      var img = gift.querySelector(IMG);
      var title = img && img.alt ? img.alt.trim() : '';
      if (!title) return;
      gift.dataset.dcGiftBound = '1';
      gift.classList.add('dc-gift-clickable');
      gift.addEventListener('click', function (e) { if (e.target.closest(VARIANT)) return; clickGift(title); });
    });
  }

  attach();
  new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
  modal.querySelector('.dc-gift-close').addEventListener('click', close);
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
})();
